import { httpClient } from '@/services/http/httpClient'

export async function updateAllCategoryVideosAsWatched(category: string) {
  return await httpClient.put(`/users/videos/categories/watched`, {
    category,
  })
}
